import { IconProps, NocIconGenerator } from '../common';

export const Wifi = (props: IconProps): JSX.Element => (
    <NocIconGenerator
        {...props}
        createIconProps={{
            displayName: 'Wifi',
            path: (
                <>
                    <g clipPath="url(#clip0_2311_188)">
                        <path
                            d="M16.5 15.0943C14.01 12.4243 9.99 12.4243 7.5 15.0943M19.5 12.0943C15.36 6.76433 8.64 6.76433 4.5 12.0943M22 8.59433C16.37 1.92433 7.63 1.92433 2 8.59433M10.2857 18.2372C10.2857 19.1858 11.0514 19.9515 12 19.9515C12.9486 19.9515 13.7143 19.1858 13.7143 18.2372C13.7143 17.2886 12.9486 16.5229 12 16.5229C11.0514 16.5229 10.2857 17.2886 10.2857 18.2372Z"
                            stroke="black"
                            strokeWidth="0.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_2311_188">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                    </defs>
                </>
            ),
        }}
    />
);
